import React from 'react';
import styled from 'styled-components';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';

export default function DropdownItem(props) {
	const {id, key, className, currentItem, indexItem, title, onClick, children, disabled, type} = props;
	return (
		<StyledMotifDropdownItem
			id={id}
			key={key}
			className={className}
			currentItem={currentItem}
			indexItem={indexItem}
			title={title}
			onClick={onClick}
			disabled={disabled}
			type={type}
		>
			{children}
		</StyledMotifDropdownItem>
	);
}

const StyledMotifDropdownItem = styled(MotifDropdownItem)``;
